import { render, staticRenderFns } from "./AddOn.vue?vue&type=template&id=141ba1cc&scoped=true&"
import script from "./AddOn.vue?vue&type=script&lang=js&"
export * from "./AddOn.vue?vue&type=script&lang=js&"
import style0 from "./AddOn.vue?vue&type=style&index=0&id=141ba1cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ba1cc",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QCheckbox,QItemLabel});
